import { render, staticRenderFns } from "./FeaturesSection.vue?vue&type=template&id=25ba9c50&lang=pug&"
import script from "./FeaturesSection.vue?vue&type=script&lang=js&"
export * from "./FeaturesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports